import { render, staticRenderFns } from "./commission_order.vue?vue&type=template&id=00d11bc4&scoped=true"
import script from "./commission_order.vue?vue&type=script&lang=js"
export * from "./commission_order.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d11bc4",
  null
  
)

export default component.exports